import React, { useState } from 'react';
import {SimulatorOfferModel,DiscountModel,YesNo} from '../models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
type Props = {
    discount:any;
    onChanged:any;
  };
  
  
  type State = {
    discount:any;
    onChanged:any;
    sum:number,    
    };

export class MigdalDiscount extends React.Component<Props,State>
{
    constructor(props:any) {
        super(props); 
        
        this.state = {
            discount:this.props.discount,
            onChanged:null,
            sum:this.props.discount.sum
        }
        
      }

      setCheckboxStateData = (name:string,event:any) => {
        
        const data = this.state.discount;
        data[name] = event.currentTarget.checked;
        this.setState({discount: data});

      }

      setStateInputData = (name:string,event:any) => {
        
        console.log('setStateInputData', name, event);

        let input = parseInt(event.target.value);
        
        // Check if newValue exceeds max
        if (input > event.target.max) {
          input = parseInt(event.target.max);
        }
        
        // Check if newValue is less than min
        if (input < event.target.min) {
          input = parseInt(event.target.min);
        }


        const data = this.state.discount;
        data[name] = input;
        this.setState({discount: data});
        this.props.onChanged(data);
      }

      setAutoActive = async (name:string,event:any) => {
        
        const data = this.state.discount;

        if(event.currentTarget.checked)
            data.autoActive=YesNo._0;
        else
            data.autoActive=YesNo._1;
       await this.setState({discount: data}, ()=>{
          this.props.onChanged(data);
        });
        console.log('setAutoActive', name);
      }
      
      
    render() {

       return (        
        <>{this.state.discount!=null?
            <>
            <div className="form-table-row flex-space-between flex-centered">
       <div className="form-table-column">
           <div className="input-row">
     
           <input  type="checkbox" onChange={(e:any) =>  this.setAutoActive("autoActive", e)} checked={this.state.discount.autoActive==YesNo._0} />
                     <label>{this.state.discount.name}</label>         
           </div>
       </div>
       <div className="form-table-column">
           <div className="input-row">
               <div className="input-wrapper flex-space-between flex-centered">
                   <div className=" small-icon  pointer">
                   <input type="number" min={0} max={this.state.sum} className={this.state.discount.autoActive==YesNo._0?"":"disabled"}  onChange={(e:any) =>  this.setStateInputData("sum", e)} value={this.state.discount.sum} />
                     </div>%
               </div>
           </div>
       </div>
       {/* <div className="form-table-column">
           <div className="input-row">
           <div className="input-wrapper flex-space-between flex-centered">
                   <div className=" small-icon  pointer">
                   <input type="number" onChange={(e:any) =>  this.setStateInputData("ayalonHanachatHatama", e)} value={this.state.discount.ayalonHanachatHatama} />
                     </div>%
               </div>
           </div>
       </div> */}
     </div>
             </>
            :""}</>
       );

        
      }
  }
